import * as React from "react";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from "react-redux";
import { useModules } from '../../utils/modules';
import OrgAccessComponent from '../Header/OrgAccess';
import AssociatedPartiesComponent from '../Header/AssociatedParties';
import NotificationComponent from '../Header/Notification';
import { showRightPopUpeBox, hideRightPopUpBox } from "../../components/RightPopUpComponent/actions";
import { getAUCounts, setActiveTopHeader, fetchUserOrgNameSuggestions, fetchLeftNavigation } from '../Header/actions/action';
import { fetchSessionContextOidcRequest } from '../../common/reducers/sessionContextOidc';
import { fetchNavigationRequest } from '../../common/slice/navigation';
import { getWorkkardDetailMasterData } from "../../containers/WorkkardDetail/actions/action";
import RightPopUpComponent from "../../components/RightPopUpComponent";
import DialogueBox from '../../components/DialogueBox';
import { showDialogueBox, hideDialogueBox } from '../../components/DialogueBox/actions';
import ActionCenter from "./actionCenter";
import Tooltip from '../../components/Tooltip';
import Toast from '../../components/Toast';
import { hideTooltip, hideToast } from '../SpockViewPage/actions/action';
import { fetchDiaryInfo, resetViewDiaryInfo } from "../Diaries/actions";
import DiaryDetailPopUp from '../../components/DiaryDetailPopUp';
import ManageProfile from "./ManageProfile";
import * as CommonUtil from "../../common/util";
import { TitlePrefix } from "../../common/constants";
import { Outlet } from "react-router-dom";
import { useLegacyHistory } from "../../router/hooks";

const Header = (props) => {
    const dispatch = useDispatch();
    const { history } = useLegacyHistory();
    const { isModuleEnabled } = useModules();
    const organizationName = useSelector((state) => {
        return state.sessionContextOidc.organizationView ? state.sessionContextOidc.organizationView.OrganizationName : null;
    });
    const rightPopUpComponent = useSelector(state => state.rightPopUpComponent);
    const dialogueBox = useSelector(state => state.dialogueBox);
    const newNotificationCount = useSelector(state => state.header.notification.newNotificationCount);
    const activeTopHeader = useSelector(state => state.header.headerObject.activeHeader);
    const tooltip = useSelector(state => state.tooltip);
    const toast = useSelector(state => state.toast);

    const showRightPopUpBox = (childComponent, panel, type) => {
        if (rightPopUpComponent.flag) {
            dispatch(hideRightPopUpBox());
        }
        dispatch(showRightPopUpeBox({
            flag: true,
            component: childComponent,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true,
            type: type || "open",
            panelType: panel
        }));
    };

    const closeRightPopUp = () => {
        $(".headerRight li").removeClass("active");
        $(".headerRight li").removeAttr("name");
        dispatch(hideRightPopUpBox());
        dispatch(setActiveTopHeader({ activeHeader: "" }));
    };

    const onDialogueClose = () => {
        dispatch(showDialogueBox({
            flag: false,
            title: null,
            dialogueBoxComponent: null
        }));
        CommonUtil.clearProfileHash(history);
    };

    const onTooltipClose = () => {
        dispatch(hideTooltip());
    };

    const openDiaryDetail = (value) => {
        if (!isModuleEnabled("diaries")) return;
        dispatch(fetchDiaryInfo({
            target: null,
            id: value.id,
            key: 'views',
            isErrorScreen: true
        }));
        dispatch(showDialogueBox({
            flag: true,
            component: (
                <DiaryDetailPopUp
                    dataKey={'views'}
                    wkId={value.cid}
                    actId={value.actid || 0}
                    onClose={() => {
                        window.location.reload();
                        dispatch(hideDialogueBox());
                        dispatch(resetViewDiaryInfo());
                    }}
                />
            ),
            overlayClassName: "modal",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: false,
        }));
    };

    const closeToast = () => {
        let domainName = $('#siteUrl').val();
        Cookies.set('Show_Is_Toast_Displayed', 'true', { domain: domainName });
        dispatch(hideToast());
    };

    const onViewToastClick = (type, cid, actid, hash) => {
        dispatch(showDialogueBox({
            flag: true,
            component: <ManageProfile onClose={() => { dispatch(hideDialogueBox()); }} />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        }));
        let redirectPath = { hash: `${hash}` };
        closeToast();
        CommonUtil.redirectURL(props.history, { ...props.history.location, ...redirectPath });
    };

    React.useEffect(() => {
        dispatch(fetchSessionContextOidcRequest());
        dispatch(fetchNavigationRequest());
        dispatch(getAUCounts({ _: + new Date }));

        const handleViewDiaryClicked = (e) => {
            if (e.detail.cid)
                dispatch(getWorkkardDetailMasterData({ cId: e.detail.cid, doNotUpdateActivityListing: true }));
            openDiaryDetail(e.detail);
        };
        window.addEventListener('viewDiaryClicked', handleViewDiaryClicked);
        return () => {
            window.removeEventListener('viewDiaryClicked', handleViewDiaryClicked);
        };
    }, []);

    React.useEffect(() => {
        if (organizationName) {
            document.title = `${TitlePrefix}${organizationName}`;
        }
    }, [organizationName]);

    React.useEffect(() => {
        document.getElementById("container").style.display = "block";
        if (newNotificationCount == 0) {
            $('.new_updates').hide();
        } else if (newNotificationCount > 0 && !rightPopUpComponent.flag) {
            $('.new_updates').show();
        }
    });

    const prevDialogueFlagRef = React.useRef(dialogueBox.flag);
    React.useEffect(() => {
        if (prevDialogueFlagRef.current === true && dialogueBox.flag === false) {
            onDialogueClose();
        }
        prevDialogueFlagRef.current = dialogueBox.flag;
    }, [dialogueBox.flag]);

    const prevActiveTopHeaderRef = React.useRef(activeTopHeader);
    React.useEffect(() => {
        if (activeTopHeader && prevActiveTopHeaderRef.current !== activeTopHeader) {
            if (activeTopHeader == "orgaccess")
                showRightPopUpBox(<OrgAccessComponent onClose={closeRightPopUp} />, "orgAccess");
            else if (activeTopHeader == "parties")
                showRightPopUpBox(<AssociatedPartiesComponent onClose={closeRightPopUp} />, "parties");
            else if (activeTopHeader == "notification")
                showRightPopUpBox(<NotificationComponent onClose={closeRightPopUp} />, "notification");
            else if (activeTopHeader == "actioncenter")
                showRightPopUpBox(<ActionCenter onClose={closeRightPopUp} />, "actioncenter");
            else if (activeTopHeader == "createAssociatedParties")
                showRightPopUpBox(<AssociatedPartiesComponent onClose={closeRightPopUp} createAssociatedParties='createAssociatedParties' />, "createAssociatedParties");
        }
        prevActiveTopHeaderRef.current = activeTopHeader;
    }, [activeTopHeader]);

    return (
        <React.Fragment>
            <RightPopUpComponent
                {...rightPopUpComponent}
                isOpen={rightPopUpComponent.flag}
                onClose={closeRightPopUp}
            >
                {rightPopUpComponent.component}
            </RightPopUpComponent>

            <DialogueBox
                {...dialogueBox}
                isOpen={dialogueBox.flag}
                onRequestClose={onDialogueClose}>
                {dialogueBox.component}
            </DialogueBox>
            {
                // sessionContext && sessionContext.UserView &&  <HeaderTemplate />
            }
            {tooltip.show &&
                <Tooltip
                    position={tooltip.position}
                    target={tooltip.target}
                    toolTipClassName={tooltip.toolTipClassName}
                    showOnClick={tooltip.showOnClick}
                    // onTooltipClose={hideTooltip}
                    delayTime={tooltip.delayTime}
                    hideOnDocClick={tooltip.hideOnDocClick}
                    onTooltipClose={onTooltipClose}
                >
                    {tooltip.childComponent}
                </Tooltip>
            }
            {toast.show && (toast.entityType == "timezone" || toast.entityType == "publicapi") &&
                <Toast
                    message={toast.message}
                    type={toast.type}
                    delayTime={toast.delayTime}
                    closeToast={() => closeToast()}
                    show={toast.show}
                    showActions={toast.showActions}
                    autoClose={toast.autoClose}
                    isCloseIcon={toast.isCloseIcon}
                    onViewToastClick={onViewToastClick}
                    entityType={toast.entityType}
                    cId={toast.cId}
                    actId={toast.actId}
                    iconType={toast.iconType}
                    addStyle={true}
                >
                </Toast>
            }
            <Outlet />
        </React.Fragment>
    );
};

export default Header;
